//GeneratorFlag:[NoChange]
import AccessToken from './access-token';

export default {AccessToken}
export{AccessToken}